<template>
   <section>
      <div class="container">
         <div class="row">
            <div class="col-md-8 col-sm-12">
               
               <!-- /.Article -->
               <article class="blog-news detail-wrapper">
                  <div class="full-blog">
                  
                     <!-- Featured Image -->
                     <figure class="img-holder">
                        <a href="javascript:void(0)"><img :src="blog.HomeImage" class="img-responsive" alt=""></a>
                        <div class="blog-post-date theme-bg">
                           {{ parseInt(blog.CreateTime) * 1000 | dateFormat('YYYY-MM-DD', $i18n.locale) }}
                        </div>
                     </figure>
                     
                     <!-- Blog Content -->
                     <div class="full blog-content">
                        <div class="post-meta">作者: <a href="javascript:void(0)" class="author theme-cl">{{ blog.Author }}</a></div>
                        <a href="javascript:void(0)"><h1>{{ blog.Title }}</h1></a>
                        <div class="blog-text">
                           <div v-html="blog.Content" class="blog-content">
                           </div>
                           
                        </div>
                        
                        <!-- Blog Share Option -->
                        <div class="row no-mrg">
                           <div class="blog-footer-social">
                              <span>{{ $t('blog.share') }} <i class="fa fa-share-alt"></i></span>
                              <Share :config="config" />
                           </div>
                        </div>                        
                     </div>
                     <!-- Blog Content -->
                  </div>
               </article>
               
            </div>            
            <div class="col-md-4 col-sm-12">
               <div class="sidebar">
                  <div class="widget-boxed">
                     <div class="widget-boxed-header border-0">
                        <h4>分类</h4>
                     </div>
                     <div class="widget-boxed-body padd-top-10 padd-bot-0">
                        <div class="side-list">
                           <el-tree
                             :data="category"
                             :props="defaultProps"
                             :highlight-current="true"
                             accordion
                             @node-click="handleNodeClick">
                           </el-tree>
                        </div>
                     </div>
                  </div>

                  <div class="widget-boxed">
                     <div class="widget-boxed-header">
                        <h4>相关文章</h4>
                     </div>
                     <div class="widget-boxed-body padd-top-10 padd-bot-0">
                        <div class="side-list">
                           <ul class="category-list">
                              <li v-for="c in related" :key="c.id"><router-link :to="'/blogs/' + c.url_name">{{ c.Title }}</router-link></li>
                           </ul>
                        </div>
                     </div>
                  </div>

                                 
               </div>
            </div>
         </div>
      </div>
   </section>
</template>
<style>
.full-blog h1 {
   font-size: 27px;
}
.img-responsive {
}
@media only screen  and (min-width : 993px) {
   .blog-text section {
      padding: 0px;
      background: transparent;
   }
}
img {
   max-width: 100%;
}
.blog-text section {
   padding: 0px;
   background: transparent;
}
</style>
<script>
// @ is an alias to /src
import Share from 'vue-social-share'

export default {
  name: 'BlogContent',
  data: function () {
   return {
     blog: null,
     related: [],
     defaultProps: {
      children: 'children',
      label: 'value'
     }
   }
  },
  props: ['category'],
  components: {
    Share
  },
  computed: {
    config: function() {
      return {
        title: this.blog.subject,
        description: this.blog.content,
        disabled: ['google', 'facebook', 'twitter', 'diandian', 'linkedin', 'tencent'], // 禁用的站点
        wechatQrcodeTitle: this.$t('blog.wechat'),
        wechatQrcodeHelper: ''
      }
    },
  },
  watch: {
    "$route.params.id": function(val) {
      this.loadData()
    }
  },
  methods: {
    loadData: function() {
        //get blogs
       let that = this,
          blogId = this.$route.params.id,
          tag = ''
      this.$http.get(this.BLOG_API_PREFIX + 'detail.html?url=' + blogId).then(function (response) {
        that.blog = response.data.info.detail
        tag = that.blog.Tag
      }).catch(function (error) {
        console.log(error)
      });

      this.$http.get(this.BLOG_API_PREFIX + 'relatedlinks.html?tag=' + encodeURI(tag)).then(function (response) {
        that.related = response.data.info.list
      }).catch(function (error) {
        console.log(error)
      });
      
    },
    handleNodeClick(data) {
      //this.title1 = data.name
      //console.log(data)
      //this.loadData()
      this.$router.push({
        path: '/blogs?cat=' + data.url_name
      })
    }
  },
  created: function() {
    this.loadData()
  }
}
</script>